<template>
  <v-card outlined class="mb-3">
    <v-card-subtitle class="d-flex align-center pb-2">
      <v-icon small color="primary" class="mr-2">mdi-food-apple-outline</v-icon>
      <span class="font-weight-bold primary--text">{{ $t("normativ") }}</span>
    </v-card-subtitle>
    <v-card-text class="pt-0">
      <grocery-picker
        v-model="selectedGrocery"
        :groceries="availableGroceries"
        hide-details
        @input="addGrocery"
      />
      <v-divider
        class="my-2"
        v-if="editedItem.groceries && editedItem.groceries.length"
      ></v-divider>
      <div
        v-if="editedItem.groceries && editedItem.groceries.length"
        class="groceries-list-no-scroll"
      >
        <div
          v-for="grocery in editedItem.groceries"
          :key="grocery.id"
          class="grocery-item"
        >
          <span class="grey--text text-body-2 mr-2" style="min-width: 60px">
            {{ grocery.code }}
          </span>
          <span class="flex-grow-1 text-body-2">{{ grocery.name }}</span>
          <text-field
            v-model="grocery.pivot.quantity"
            type="number"
            dense
            hide-details
            outlined
            style="max-width: 90px"
            class="mx-2"
          />
          <span class="grey--text text-body-2 mr-2" style="min-width: 40px">
            {{ grocery.measure }}
          </span>
          <remove-button @click="removeGrocery(grocery)" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import GroceryPicker from "@/components/groceries/fields/GroceryPicker.vue";
import groceryService from "@/services/grocery";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  mixins: [hasSnackbar],
  components: {
    GroceryPicker,
  },
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    selectedGrocery: null,
    itemsGroceries: [],
    loading: false,
  }),
  created() {
    this.loadGroceries();
  },
  methods: {
    loadGroceries() {
      this.loading = true;
      groceryService
        .getGroceries()
        .then((res) => {
          this.itemsGroceries = res.data;
        })
        .catch((error) => {
          console.error("Error loading groceries:", error);
          this.showErrorSnackbar(this.$t("error_loading_groceries"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addGrocery(grocery) {
      if (!grocery) return;
      if (!this.editedItem.groceries) {
        this.editedItem.groceries = [];
      }
      const exists = this.editedItem.groceries.find((g) => g.id === grocery.id);
      if (!exists) {
        this.editedItem.groceries.unshift({
          ...grocery,
          pivot: { quantity: 0 },
        });
      }
      this.$nextTick(() => {
        this.selectedGrocery = null;
      });
    },
    removeGrocery(item) {
      const index = this.editedItem.groceries.findIndex((i) => i.id === item.id);
      if (index !== -1) {
        this.editedItem.groceries.splice(index, 1);
      }
    },
  },
  computed: {
    availableGroceries() {
      if (!this.editedItem || !this.editedItem.groceries) {
        return this.itemsGroceries || [];
      }
      return this.editedItem?.groceries
        ? (this.itemsGroceries || []).filter(
            (item) =>
              !this.editedItem.groceries.some((grocery) => grocery.id === item.id) &&
              item?.id
          )
        : this.itemsGroceries;
    },
  },
};
</script>

<style scoped>
.grocery-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.grocery-item:last-child {
  border-bottom: none;
}

.grocery-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
}
</style>
